export default __webpack_public_path__ + "static/media/AccessoriesNeeded.98c6dbfe.png";